import { FC, useMemo } from "react";

import { useGetLabelListForWorkspace } from "@/domain/label/hooks/api/use-get-label-list-for-workspace";

import { type LabelAssignmentContext } from "./label-assignment-context";
import { LabelListItem } from "./label-list-item";

interface LabelListProps {
  workspaceId: string;
  labelAssignmentContext?: LabelAssignmentContext;
}

export const LabelList: FC<LabelListProps> = ({ workspaceId, labelAssignmentContext }) => {
  const { labelList } = useGetLabelListForWorkspace({ workspaceId });

  const sortedLabelList = useMemo(() => {
    return labelList
      .slice()
      .filter((label) => label?.id && !label.labelGroupId)
      .sort((a, b) => {
        if (!a || !b) {
          return 0;
        }
        return a.title.localeCompare(b.title);
      });
  }, [labelList]);

  if (sortedLabelList.length === 0) {
    return null;
  }

  return (
    <div className="rounded-md border border-border px-2 py-1">
      {sortedLabelList.map((label) => (
        <LabelListItem
          key={label.id}
          labelId={label.id}
          workspaceId={workspaceId}
          labelAssignmentContext={labelAssignmentContext}
        />
      ))}
    </div>
  );
};
